export const texts = {
  fr: {
    title: "Mawered",
    subtitle: "La Plateforme RH Complète pour les Entreprises EMEA",
    loginTitle: "Connexion",
    loginSubtitle: "Connectez-vous avec vos identifiants pour accéder au système",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    usernamePlaceholder: "Entrez votre nom d'utilisateur",
    passwordPlaceholder: "Entrez votre mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    loginButton: "Se connecter",
    loginProgress: "Connexion en cours...",
    testCredentials: "Identifiants de test",
    strongPassword: "Fort",
    mediumPassword: "Moyen",
    weakPassword: "Faible",
    passwordStrength: "Force du mot de passe",
    privacyPolicy: "Politique de confidentialité",
    technicalSupport: "Support technique",
    copyright: "© 2026 Mawered. Tous droits réservés. Powered by Teknovat",
    help: "Aide",
    secureUsage: "Utilisation sécurisée",
    secureDescription: "Vos données sont protégées par un chiffrement SSL",
    supportAvailable: "Support disponible",
    supportDescription: "Contactez l'administrateur en cas de problème",
    invalidCredentials: "Nom d'utilisateur ou mot de passe incorrect",
    requiredField: "Ce champ est requis",
    checkInfoRetry: "Veuillez vérifier vos informations et réessayer.",
    testCredentialsNote: "Ces identifiants sont fournis pour les tests et la démonstration du système.",
    trialExpiredTitle: "Période d'essai terminée",
    trialExpiredMessage: "Votre période d'essai gratuite a expiré. Souscrivez à un abonnement pour continuer à utiliser Mawered.",
    accountSuspendedTitle: "Compte suspendu",
    accountSuspendedMessage: "Votre compte a été suspendu. Veuillez contacter le support ou procéder au paiement pour le réactiver.",
    trialEndedOn: "Essai terminé le",
    seeOffers: "Voir les offres",
    contactSupport: "Contacter le support",
    noAccount: "Pas encore de compte ?",
    createAccount: "Créer un compte",
    paymentInitError: "Erreur lors de l'initiation du paiement",
    billingMonthly: "Mensuel",
    billingAnnual: "Annuel",
    paymentPerMonth: "DT/mois",
    paymentPerYear: "DT/an",
    choosePaymentMethod: "Choisir votre mode de paiement",
    backToPlans: "Retour aux offres",
    backToLogin: "Retour à la connexion",
    popularPlan: "Populaire",
    pay: "Payer",
  },
  en: {
    title: "Mawered",
    subtitle: "The Complete HR Platform for EMEA Businesses",
    loginTitle: "Login",
    loginSubtitle: "Sign in with your credentials to access the system",
    username: "Username",
    password: "Password",
    usernamePlaceholder: "Enter your username",
    passwordPlaceholder: "Enter your password",
    forgotPassword: "Forgot password?",
    loginButton: "Sign In",
    loginProgress: "Signing in...",
    testCredentials: "Test credentials",
    strongPassword: "Strong",
    mediumPassword: "Medium",
    weakPassword: "Weak",
    passwordStrength: "Password strength",
    privacyPolicy: "Privacy Policy",
    technicalSupport: "Technical Support",
    copyright: "© 2026 Mawered. All rights reserved. Powered by Teknovat",
    help: "Help",
    secureUsage: "Secure usage",
    secureDescription: "Your data is protected by SSL encryption",
    supportAvailable: "Support available",
    supportDescription: "Contact administrator if you have issues",
    invalidCredentials: "Invalid username or password",
    requiredField: "This field is required",
    checkInfoRetry: "Please check your information and try again.",
    testCredentialsNote: "These credentials are provided for testing and demonstration purposes.",
    trialExpiredTitle: "Trial Period Ended",
    trialExpiredMessage: "Your free trial has expired. Subscribe to a plan to continue using Mawered.",
    accountSuspendedTitle: "Account Suspended",
    accountSuspendedMessage: "Your account has been suspended. Please contact support or make a payment to reactivate it.",
    trialEndedOn: "Trial ended on",
    seeOffers: "See Plans",
    contactSupport: "Contact Support",
    noAccount: "Don't have an account?",
    createAccount: "Create an account",
    paymentInitError: "Error initiating payment",
    billingMonthly: "Monthly",
    billingAnnual: "Annual",
    paymentPerMonth: "DT/month",
    paymentPerYear: "DT/year",
    choosePaymentMethod: "Choose your payment method",
    backToPlans: "Back to plans",
    backToLogin: "Back to login",
    popularPlan: "Popular",
    pay: "Pay",
  },
  ar: {
    title: "Mawered",
    subtitle: "منصة الموارد البشرية الشاملة لشركات الشرق الأوسط وأوروبا وأفريقيا",
    loginTitle: "تسجيل الدخول",
    loginSubtitle: "قم بتسجيل الدخول باستخدام بيانات الاعتماد الخاصة بك للوصول إلى النظام",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    usernamePlaceholder: "أدخل اسم المستخدم",
    passwordPlaceholder: "أدخل كلمة المرور",
    forgotPassword: "هل نسيت كلمة المرور؟",
    loginButton: "تسجيل الدخول",
    loginProgress: "جاري تسجيل الدخول...",
    testCredentials: "بيانات الاختبار",
    strongPassword: "قوية",
    mediumPassword: "متوسطة",
    weakPassword: "ضعيفة",
    passwordStrength: "قوة كلمة المرور",
    privacyPolicy: "سياسة الخصوصية",
    technicalSupport: "الدعم الفني",
    copyright: "© 2026 Mawered. جميع الحقوق محفوظة. Powered by Teknovat",
    help: "مساعدة",
    secureUsage: "استخدام آمن",
    secureDescription: "بياناتك محمية بتشفير SSL",
    supportAvailable: "الدعم متاح",
    supportDescription: "اتصل بالمسؤول إذا واجهت أي مشاكل",
    invalidCredentials: "اسم المستخدم أو كلمة المرور غير صحيحة",
    requiredField: "هذا الحقل مطلوب",
    checkInfoRetry: "يرجى التحقق من معلوماتك والمحاولة مرة أخرى.",
    testCredentialsNote: "يتم توفير بيانات الاعتماد هذه لأغراض الاختبار والعرض التوضيحي.",
    trialExpiredTitle: "انتهت فترة التجربة",
    trialExpiredMessage: "لقد انتهت فترة التجربة المجانية الخاصة بك. يرجى الاشتراك في خطة لمواصلة استخدام Mawered.",
    accountSuspendedTitle: "الحساب معلق",
    accountSuspendedMessage: "تم تعليق حسابك. يرجى التواصل مع الدعم أو إتمام الدفع لإعادة التفعيل.",
    trialEndedOn: "انتهت التجربة في",
    seeOffers: "عرض الخطط",
    contactSupport: "التواصل مع الدعم",
    noAccount: "ليس لديك حساب؟",
    createAccount: "إنشاء حساب",
    paymentInitError: "حدث خطأ أثناء بدء عملية الدفع",
    billingMonthly: "شهري",
    billingAnnual: "سنوي",
    paymentPerMonth: "د.ت/شهر",
    paymentPerYear: "د.ت/سنة",
    choosePaymentMethod: "اختر طريقة الدفع",
    backToPlans: "العودة إلى الخطط",
    backToLogin: "العودة إلى تسجيل الدخول",
    popularPlan: "الأكثر شيوعاً",
    pay: "ادفع",
  },
};

export const PLANS = [
  {
    code: "STARTER",
    name: "Starter",
    monthlyDT: 99,
    annualDT: 990,
    employees: { fr: "50", en: "50", ar: "50" },
    storage: { fr: "10 Go", en: "10 GB", ar: "10 جيجابايت" },
    color: "indigo",
    features: {
      fr: ["Gestion employés", "Pointages & présences", "Planning", "Rapports de base"],
      en: ["Employee management", "Attendance tracking", "Planning", "Basic reports"],
      ar: ["إدارة الموظفين", "الحضور والانصراف", "التخطيط", "تقارير أساسية"],
    },
  },
  {
    code: "PROFESSIONAL",
    name: "Professional",
    monthlyDT: 249,
    annualDT: 2490,
    employees: { fr: "200", en: "200", ar: "200" },
    storage: { fr: "50 Go", en: "50 GB", ar: "50 جيجابايت" },
    color: "violet",
    popular: true,
    features: {
      fr: ["Tout Starter", "Paie avancée", "Jours fériés", "Intégration ZKTeco"],
      en: ["Everything in Starter", "Advanced payroll", "Public holidays", "ZKTeco integration"],
      ar: ["كل مزايا Starter", "رواتب متقدمة", "العطل الرسمية", "تكامل ZKTeco"],
    },
  },
  {
    code: "ENTERPRISE",
    name: "Enterprise",
    monthlyDT: 999,
    annualDT: 9990,
    employees: { fr: "Illimité", en: "Unlimited", ar: "غير محدود" },
    storage: { fr: "500 Go", en: "500 GB", ar: "500 جيجابايت" },
    color: "purple",
    features: {
      fr: ["Tout Professional", "Multi-sites", "Accès API", "Support prioritaire"],
      en: ["Everything in Professional", "Multi-site", "API access", "Priority support"],
      ar: ["كل مزايا Professional", "متعدد المواقع", "وصول API", "دعم ذو أولوية"],
    },
  },
];
